
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../node_modules/babel-loader/lib/index.js??ref--0!./stage.jsx"));
			});
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./~/preact-cli/lib/lib/webpack/async-component-loader.js!./components/stage/stage.jsx
// module id = QROJ
// module chunks = 4